import { StateProvider, StateParams, StateService } from "@uirouter/angularjs";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import { vsComponentName as ContractEditComponentName } from "./views/edit/component";
import { vsComponentName as ProcessTemplateComponentName } from "./views/template/component";
import { vsComponentName as ProcessTemplateEditComponentName } from "./views/template/edit/component";
import { vsObjectName as contractObjectName } from "./configs/contract";

import { vsName as ContractMachineDetailComponent } from "./views/info/component";
import { ServiceResponse } from "../records/server/query";
import {
  vsComponentName as RecordGridViewComponentName,
  vsServiceName as RecordGridViewServiceName,
  RecordGridViewService,
  GridConfiguration,
} from "../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../records/grids/settings/gridSettingsService";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../records/grids/columns/columnDefinitionService";
export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.contract", {
      url: "contract",
      template: "<ui-view></ui-view>",
      abstract: true,
    })
    .state("main.contract.grid", {
      url: "/grid",
      component: RecordGridViewComponentName,
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(contractObjectName),
        ],
        gridDataSource: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.gridDataSource,
        ],
        gridSettings: [
          GridSettingsServiceName,
          (gridSettingsService: GridSettingsService) =>
            gridSettingsService.getGridSettings(Symbol("main.contract.grid")),
        ],
        defaultSort: [() => "-ContractStartDate"],
        nameSingular: [() => "Contract"],
        showAddButton: [() => true],
        showAddButtonPermission: [
          () => ["contractEdit", "contractViewSensitive"],
        ],
        onAddNew: [
          "$state",
          ($state: StateService) => () => $state.go("^.Add"),
        ],
        columns: [
          "gridConfiguration",
          ColumnDefinitionServiceName,
          (
            gridConfiguration: GridConfiguration,
            columnDefinitionService: ColumnDefinitionService
          ) => [
            columnDefinitionService.getLinkColDef({
              headerName: "info",
              iconClass: "fa fa-info-circle text-primary",
              colId: "detail",
              width: 20,
              stateExpression:
                "main.contract.info.Machine({ contractId: data.Id})",
            }),
            columnDefinitionService.getLinkColDef({
              headerName: "edit",
              iconClass: "fa fa-pencil text-primary",
              colId: "edit",
              stateExpression: "main.contract.Edit({ contractId: data.Id})",
              requiresPermission: ["contractEdit", "contractViewSensitive"],
            }),
            ...(gridConfiguration.columns ?? []),
          ],
        ],
      },
    })
    .state("main.contract.Add", {
      url: "/add",
      component: ContractEditComponentName,
    })
    .state("main.contract.Edit", {
      url: "/edit/{contractId:int}",
      component: ContractEditComponentName,
      resolve: {
        contract: [
          ServerUtilityName,
          "$stateParams",
          function (serverUtility: ServerUtility, $stateParams: StateParams) {
            const contractId = $stateParams["contractId"];
            return serverUtility
              .sendApiRequest({
                method: "get",
                url: `api/contract/contract/${contractId}`,
              })
              .then((r) => <ServiceResponse<unknown>>r);
          },
        ],
      },
    })
    .state("main.contract.info", {
      url: "/{contractId:int}/info",
      component: ContractMachineDetailComponent,
      resolve: {
        contractId: [
          "$stateParams",
          function ($stateParams: StateParams) {
            return $stateParams["contractId"];
          },
        ],
        contract: [
          ServerUtilityName,
          "contractId",
          function (serverUtility: ServerUtility, contractId: number) {
            return serverUtility
              .sendApiRequest({
                method: "get",
                url: `api/contract/contract/${contractId}`,
              })
              .then((r) => <ServiceResponse<unknown>>r);
          },
        ],
        contractMachines: [
          ServerUtilityName,
          "contractId",
          function (serverUtility: ServerUtility, contractId: number) {
            return serverUtility
              .sendApiRequest({
                method: "get",
                url: `api/contract/contractMachines/${contractId}`,
              })
              .then((r) => (<ServiceResponse<unknown>>r).Results);
          },
        ],
      },
    })
    .state("main.contract.process.template", {
      url: "/template",
      component: ProcessTemplateComponentName,
    })
    .state("main.contract.process.template.edit", {
      url: "/edit/{templateId:int}",
      component: ProcessTemplateEditComponentName,
      resolve: {
        template: [
          ServerUtilityName,
          "$stateParams",
          function (serverUtility: ServerUtility, $stateParams: StateParams) {
            const templateId = $stateParams["templateId"];
            return serverUtility
              .sendApiRequest({
                method: "get",
                url: `api/process/template/${templateId}`,
              })
              .then((r) => (<ServiceResponse<unknown>>r).Results);
          },
        ],
      },
    });
}
routeConfig.$inject = ["$stateProvider"];
